import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

const Section = ({ title, children }) => (
  <div className="mb-8 md:mb-10">
    <h2 className="text-xl md:text-2xl font-heading text-headingText mb-3 md:mb-4">{title}</h2>
    <div className="text-sm md:text-base text-bodyText leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* Header */}
      <div className="text-center mb-10 md:mb-14">
        <p className="text-secondary font-medium tracking-widest text-xs md:text-sm uppercase mb-3">Legal</p>
        <h1 className="text-3xl md:text-5xl font-heading text-headingText mb-4">Privacy Policy</h1>
        <p className="text-sm text-bodyText opacity-70">Last updated: March 22, 2026</p>
      </div>

      <div className="bg-cardBg rounded-2xl p-6 md:p-10 shadow-sm">

        <Section title="1. Information We Collect">
          <p>When you use Panch Tatva by Anukta, we collect:</p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li><strong>Account information</strong> — name, email address (via Google Sign-In)</li>
            <li><strong>Profile information</strong> — delivery addresses, phone number (when you provide them)</li>
            <li><strong>Order information</strong> — items purchased, payment status, delivery details</li>
            <li><strong>Usage data</strong> — pages visited, browser type, device information</li>
          </ul>
        </Section>

        <Section title="2. How We Use Your Information">
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>To process and fulfill your orders</li>
            <li>To send order confirmations and shipping updates</li>
            <li>To improve our website and product offerings</li>
            <li>To respond to your support queries</li>
            <li>To comply with legal obligations</li>
          </ul>
          <p>We do <strong>not</strong> sell, rent, or share your personal information with third parties for marketing purposes.</p>
        </Section>

        <Section title="3. Authentication & Third-Party Services">
          <p>
            We use <strong>Firebase Authentication</strong> (Google) for secure sign-in. When you log in with Google,
            we receive only your name, email, and profile picture — no passwords are stored by us.
          </p>
          <p>
            Payments are processed securely via <strong>Razorpay</strong>. We do not store your card or UPI details.
          </p>
        </Section>

        <Section title="4. Data Storage & Security">
          <p>
            Your data is stored in secure cloud databases (MongoDB Atlas). We use industry-standard encryption
            and access controls. However, no internet transmission is 100% secure.
          </p>
        </Section>

        <Section title="5. Cookies">
          <p>
            We use minimal cookies to maintain your login session and cart state. We do not use third-party
            advertising cookies. You can disable cookies in your browser settings, though some features may
            not function correctly.
          </p>
        </Section>

        <Section title="6. Your Rights">
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Request access to the personal data we hold about you</li>
            <li>Request correction or deletion of your data</li>
            <li>Withdraw consent at any time by deleting your account</li>
          </ul>
          <p>
            To exercise these rights, email us at{' '}
            <a href="mailto:support@panch-tatva.co.in" className="text-secondary hover:underline">
              support@panch-tatva.co.in
            </a>
          </p>
        </Section>

        <Section title="7. Children's Privacy">
          <p>
            Our services are not directed at individuals under 18. We do not knowingly collect data from
            minors. If you believe a minor has provided us with personal information, please contact us.
          </p>
        </Section>

        <Section title="8. Changes to This Policy">
          <p>
            We may update this Privacy Policy periodically. We will notify you of significant changes via
            email or a prominent notice on our website.
          </p>
        </Section>

      </div>

      <div className="mt-10 text-center">
        <PanchTatvaButton onClick={() => navigate(-1)} variant="outline">
          ← Go Back
        </PanchTatvaButton>
      </div>
    </div>
  );
}
